import Vue from "vue";
import VueRouter from "vue-router";
import DashboardPlugin from "./material-dashboard";
import App from "./App.vue";
import ChartHelp from "@/ts/chartHelp";

// router setup
import routes from "./routes/routes";

import UUID from "vue-uuid"; 

import getCurrentConfig from "@/ts/customConfig";
Vue.prototype.$currentConfig = getCurrentConfig();

// Import the plugin here
import { Auth0Plugin } from "./auth";
var config = getCurrentConfig(); //import { domain, clientId } from "../auth_config.json";
let domain = config.domain;
let clientId = config.clientId;
let audience = config.audience;

// Install the authentication plugin here
Vue.use(Auth0Plugin, {
    domain,
    clientId,
    audience,
    onRedirectCallback: appState => {
        router.push(
            appState && appState.targetUrl
                ? appState.targetUrl
                : window.location.pathname
        );
    }
});

Vue.use(VueRouter);
Vue.use(DashboardPlugin);
Vue.use(UUID);





// configure router
import { authGuard } from "./auth/authGuard";

/* eslint-disable no-new */
const router = new VueRouter({
    mode: 'history',
    routes, 
    scrollBehavior: to => {
        if (to.hash) {
            return { selector: to.hash };
        } else {
            return { x: 0, y: 0 };
        }
    },
    linkExactActiveClass: "nav-item active"
});

router.beforeEach((to, from, next) => {
    authGuard(to, from, next);
})

//ChartJs
ChartHelp.setDefaults();

/* eslint-disable no-new */
const vueApp = new Vue({
    el: "#app",
    render: h => h(App),
    router
});

import VueAuthHref from 'vue-auth-href';
//const optionsVueAuthHref = {
//    token: () => vueApp.$auth.getTokenSilently().then(res => { return res }),
//    //{
//    //    var tokenNow = 

//    //    console.log("getting token for href");
//    //    var tokenNow = vueApp.$auth.getTokenSilently().then(result => {
//    //        tokenNow = result;
//    //    });
//    //    console.log(tokenNow);
//    //    return tokenNow;
//    //}
//};
//Vue.use(VueAuthHref, optionsVueAuthHref)
Vue.use(VueAuthHref);

export default vueApp;